import React from 'react';
import { Modal, Button, Space, Typography, Alert } from 'antd';
import { PlayCircleOutlined, LinkOutlined, CloseOutlined } from '@ant-design/icons';
import { validateVideoUrl, getPlatformInfo } from '../utils/videoUtils';

const { Text } = Typography;

const VideoPreviewModal = ({ 
    visible, 
    onClose, 
    videoUrl, 
    title = "Video Preview",
    width = 800,
    height = 450 
}) => {
    if (!videoUrl) {
        return null;
    }

    const validation = validateVideoUrl(videoUrl);
    const platformInfo = getPlatformInfo(validation.platform);

    const handleCancel = () => {
        onClose();
    };

    const handleViewOriginal = () => {
        window.open(videoUrl, '_blank');
    };

    return (
        <Modal
            title={
                <Space>
                    <span>{platformInfo.icon}</span>
                    <span>{title}</span>
                    <Text type="secondary" style={{ fontSize: '14px' }}>
                        ({platformInfo.name})
                    </Text>
                </Space>
            }
            open={visible}
            onCancel={handleCancel}
            width={width}
            centered
            footer={[
                <Button key="close" onClick={handleCancel}>
                    Close
                </Button>,
                validation.isValid && (
                    <Button 
                        key="view" 
                        type="primary" 
                        icon={<LinkOutlined />}
                        onClick={handleViewOriginal}
                    >
                        View on {platformInfo.name}
                    </Button>
                )
            ]}
            destroyOnClose
        >
            <div style={{ textAlign: 'center' }}>
                {!validation.isValid ? (
                    <Alert
                        message="Invalid Video URL"
                        description="Please enter a valid YouTube, Vimeo, or TikTok URL"
                        type="error"
                        showIcon
                        style={{ margin: '20px 0' }}
                    />
                ) : (
                    <div style={{ 
                        position: 'relative', 
                        width: '100%', 
                        height: height,
                        borderRadius: 8,
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }}>
                        <iframe
                            src={validation.embedUrl}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={title}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default VideoPreviewModal;
